export default __webpack_public_path__ + "c4e4509f0539981d215d0013b90417bc.png";